// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f_oo","newExpiryDate":"styles_newExpiryDate__1Ad57","footer":"styles_footer__1MYCW"};